export var NUMBER_OF_CAROUSEL_ITEMS_TO_DISPLAY = 3;
export var NUMBER_OF_CAROUSEL_ITEMS_TO_FETCH = 15;
export var NUMBER_OF_ENTITLEMENTS_TO_DISPLAY = 6;
export var NUMBER_OF_SERVICES_TO_DISPLAY = 5;
export var SERVICES_AND_OFFERS_TABS = {
  WIDGET_SERVICES: 'widget_new_services',
  WIDGET_OFFERS: 'widget_new_offerings',
  WIDGET_SHARED_USAGE: 'widget_shared_usage'
};